import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface ProjectVehicleIconProps {
  color?: string;
  style?: React.CSSProperties;
  height?: string;
  width?: string;
}

export default function ProjectVehicleIcon({
  color = RoutalPalette.secondary20,
  style = {},
  height = `14px`,
  width = `10px`,
}: ProjectVehicleIconProps) {
  return (
    <SvgIcon viewBox="0 0 14 10" style={{ fill: `none`, height: height, width: width, ...style }}>
      <g>
        <path
          d="M1 4.37305H12.7499"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.43945 1.07812V4.37224"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.57589 9.07743C4.39769 9.07743 5.06389 8.44537 5.06389 7.66567C5.06389 6.88597 4.39769 6.25391 3.57589 6.25391C2.75409 6.25391 2.08789 6.88597 2.08789 7.66567C2.08789 8.44537 2.75409 9.07743 3.57589 9.07743Z"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.52706 9.07743C10.3489 9.07743 11.0151 8.44537 11.0151 7.66567C11.0151 6.88597 10.3489 6.25391 9.52706 6.25391C8.70526 6.25391 8.03906 6.88597 8.03906 7.66567C8.03906 8.44537 8.70526 9.07743 9.52706 9.07743Z"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.4272 1.85836C11.1752 1.38024 10.6599 1.07812 10.0964 1.07812H1.992C1.44392 1.07812 1 1.4993 1 2.0193V7.19577C1 7.45553 1.22221 7.66636 1.496 7.66636H2.088C2.088 6.88659 2.75413 6.25459 3.576 6.25459C4.39787 6.25459 5.064 6.88659 5.064 7.66636H8.04C8.04 6.88659 8.70613 6.25459 9.528 6.25459C10.3499 6.25459 11.016 6.88659 11.016 7.66636H12.504C12.7778 7.66636 13 7.45553 13 7.19577V4.84283L11.4272 1.85836Z"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
